jQuery(document).ready(function ($) {

	$(".js-load-more:not(.is-active)").on("click", load_more);

	let page = 0;

	function load_more() {
		const $this = $(this);

		$.ajax({
			url: "/wp-json/posts/load-more/",
			method: "POST",
			data: {
				"post_type": data.post_type,
				"page": page,
				"params": window.location.search,
			},
			beforeSend: function (xhr) {
				$this.addClass("is-active");
				if (data.user.nonce) {
					xhr.setRequestHeader("X-WP-Nonce", data.user.nonce);
				}
			},
			success: function (response) {
				page = response.page;

				if (!response.more) {
					$this.closest(".u-content-footer").remove();
				}

				$(".js-output").append(response.html);

				$this.removeClass("is-active");
			},
		});


		return false;
	}
});